
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as sq from '~/store/modules/sq'
import * as cart from '~/store/modules/cart'
import * as catalog from '~/store/modules/catalog'

const SQ = namespace(sq.name)
const Cart = namespace(cart.name)
const Catalog = namespace(catalog.name)

@Component({
  components: {
    PromotionTag: () => import('~/components/Icons/PromotionTag.vue'),
    Tick2: () => import('~/components/Icons/TickAlt.vue')
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class SuggestedPromo extends Vue {
  @SQ.Getter
  sq

  @SQ.Getter
  primaryNetwork

  @Cart.Getter
  suggestedPromo

  @Cart.Getter
  suggestedPromoMinDownload

  @Cart.Getter
  suggestedPromoMinContract

  @Cart.Getter
  partner

  @Catalog.Getter
  filteredHardware

  @Catalog.Getter
  hardwareDescriptionForCode

  shouldShow(discount): boolean {
    if(discount.discountDescription === 'hidden') {
      return false
    }

    if (
      discount.name &&
      discount.name.includes('PERCENT-AFTER') &&
      this.partner &&
      this.partner === 'LNDL'
    ) {
      return false
    }

    if (discount.name && discount.name.includes('ROUTER-DISCOUNT-AFTER')) {
      return false
    }
    if (
      discount.name &&
      discount.name.includes('SPECIAL-PLAN') &&
      this.suggestedPromo.discounts.find(dd =>
        dd.name.includes('UNLOCK-HARDWARE')
      )
    ) {
      return false
    }
    return true
  }

  discountConditions(promo): string {
    let conditions = '*'
    if (
      ['LNDL'].includes(this.partner)
    ) {
      conditions = `${conditions}*`
    }
    if (promo.code === 'NBN65' || promo.code === 'NBN50') {
      conditions = `${conditions} on ${promo.minDownload}Mbps down plan.`
      conditions = `${conditions} Minimum ${promo.minContract} month contract.`
      return conditions
    }
    if (this.suggestedPromoMinDownload && promo.minDownload !== promo.maxDownload && this.suggestedPromoMinDownload !== 25) {
      conditions = `${conditions} Minimum ${
        this.suggestedPromoMinDownload
      }Mbps down plan.`
    } else if (this.suggestedPromoMinDownload && promo.minDownload === promo.maxDownload && this.suggestedPromoMinDownload !== 25) {
      conditions = `${conditions} Only available on The ${
        this.suggestedPromoMinDownload
      } plan.`
    }
    if (this.suggestedPromoMinContract) {      
      conditions = `${conditions} Minimum ${
        this.suggestedPromoMinContract
      } month contract.`
    }
    return conditions !== '*' ? conditions : '';
  }

  formatPromoDescription(desc, duration, applicableTo: string[], partner = false, description: string|null = null): string {
    if(description !== undefined && description !== null && description !== '') {
      return description
    }

    // $ off discounts
    if (desc.includes('recurring') && duration) {
      let promoDescription = desc
      promoDescription = `${promoDescription.replace(
        'recurring',
        ''
      )} for ${duration} months*`

      if (partner) {
        promoDescription = `${promoDescription}*`
      }

      return promoDescription
    }

    // Free router discounts
    if (desc.toLowerCase().includes('router') && applicableTo.length > 0) {
      const routers = applicableTo.map(routerCode => this.hardwareDescriptionForCode(routerCode)).join(' or ')

      return `Free ${routers}`
    }

    return desc
  }

  // Computed property that orders the discounts according to the code of the discount
  // The higher the priority the higher up the banner the entry will be.
  get discounts() {
    const codePriority = new Map<string, number>([
      [ 'RECURRING', 1000 ],
      [ 'FREE-ACTIVATION', 900 ],
      [ 'FREE-ROUTER', 800 ],
    ])

    return this.suggestedPromo.discounts
      .map((discount) => ({
          ...discount,
          codePriority: codePriority.get(discount.code) ?? 0
        })
      )
      .sort((a, b) => b.codePriority - a.codePriority)
  }
}
